import { CarouselItem } from '../../models/LessonComponentContent';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import React from 'react';

interface CarouselIndicatorsProps {
  currentIndex: number;
  carousels: CarouselItem[];
  onShowPreviousItem: () => void;
  onSelectItem: (index: number) => void;
  onShowNextItem: () => void;
}

export default function CarouselIndicators(props: CarouselIndicatorsProps) {
  const numItems = props.carousels.length || 0;

  return (
    <Grid container justifyContent={'space-around'}>
      <Grid>
        <IconButton
          size="small"
          onClick={props.onShowPreviousItem}
          disabled={props.currentIndex === 0}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
      </Grid>
      <Grid>
        {props.carousels?.map((item, idx) => (
          <IconButton
            key={`item-${idx}`}
            size="small"
            onClick={() => props.onSelectItem(idx)}
          >
            <FiberManualRecordIcon
              color={
                props.carousels[props.currentIndex]?.id === item.id
                  ? 'primary'
                  : 'disabled'
              }
              style={{ fontSize: '15px', marginTop: '6px' }}
            />
          </IconButton>
        ))}
      </Grid>
      <Grid>
        <IconButton
          size="small"
          onClick={props.onShowNextItem}
          disabled={props.currentIndex === numItems - 1}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
